import { render, staticRenderFns } from "./NewPayrun.vue?vue&type=template&id=b2f1fba0&scoped=true"
import script from "./NewPayrun.vue?vue&type=script&lang=js"
export * from "./NewPayrun.vue?vue&type=script&lang=js"
import style0 from "./NewPayrun.vue?vue&type=style&index=0&id=b2f1fba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f1fba0",
  null
  
)

export default component.exports